import { combineReducers } from 'redux';
import transfer from './transfer';
import user from './user';
import error from './error';
import country from './country';
import regions from './receiver.regions';
import regionTypes from './receiver.region.types';
import receiverNationalId from './receiverNationalId';

const rootReducer = combineReducers({
    transfer,
    user,
    error,
    country,
    regions,
    regionTypes,
    receiverNationalId,
});

export default rootReducer;
